import { render, staticRenderFns } from "./aboutlist.vue?vue&type=template&id=7ddcc5a9&scoped=true&"
import script from "./aboutlist.vue?vue&type=script&lang=js&"
export * from "./aboutlist.vue?vue&type=script&lang=js&"
import style0 from "./aboutlist.vue?vue&type=style&index=0&id=7ddcc5a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddcc5a9",
  null
  
)

export default component.exports